var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-stock-list container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", [
          _vm._v("\n                Stock list for\n                "),
          _vm.user.name && _vm.user.company
            ? _c("strong", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.user.company.name) +
                    "\n                    (" +
                    _vm._s(_vm.user.name) +
                    ")\n                "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.stock, function(item) {
                return _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-6 col-md-2" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            _vm.$laravelRoute("vehicle-stock.myGarage") +
                            "?user_id=" +
                            _vm.user.id +
                            "&sold_date=" +
                            item.sold_date
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(item.sold_date) +
                            "\n                        "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 col-md-2" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.count) +
                        "\n                    "
                    )
                  ])
                ])
              })
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col-6 col-md-2" }, [
        _c("strong", [_vm._v("Sold Date")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 col-md-2" }, [
        _c("strong", [_vm._v("# Stock")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56ec942e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56ec942e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/StockListDate.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-56ec942e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/StockListDate.vue
// module chunks = 0